module.exports = __webpack_public_path__ + "static/media/vodafone.14dd94d2.jpg";